import styles from './TestimonialsBlock.module.scss'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import TextWithIconBlock from '@/components/models/cms/blocks/TextWithIconBlock'
import travelTestimonialObject from '@/entities/travelTestimonial/interface'
import { useTranslation } from 'next-i18next'

interface Props {
  testimonials: travelTestimonialObject[]
}

const TestimonialsBlock = ({ testimonials }: Props) => {
  const { t } = useTranslation('common')
  if (!testimonials.length) {
    return <></>
  }

  return (
    <Container className={styles.root}>
      <Row>
        <h3 className={`mb-4`}>{t('travel.testimonialTitle')}</h3>
        {testimonials.map((testimonial: travelTestimonialObject, index: number) => (
          <Col md={6} key={index}>
            <TextWithIconBlock {...testimonial.contentBlock} />
          </Col>
        ))}
      </Row>
    </Container>
  )
}

export default TestimonialsBlock
